import { Typography, Box } from "@mui/material";
import { EditableInputDisplay } from "../../EditableComponents";
import { useState } from "react";
import { LoadingPaper } from "../../LoadingComponents";

export default function RecapitiDoctor({ _doctor, editMode, setParentValue }) {
  const [doctor, setDoctor] = useState(_doctor);

  return (
    <Box
      sx={{
        display: "grid",
        margin: "auto",
        gridTemplateColumns: "1fr 1fr",
        width: "100%",
      }}
    >
      {doctor !== undefined ? (
        <>
          <Box sx={{ margin: "10px" }}>
            <Typography fontWeight={"bold"} fontStyle={"italic"}>
              Indirizzo primario
            </Typography>
            <EditableInputDisplay
              id={"address"}
              label={"Indirizzo:"}
              initialValue={doctor.address}
              setEditMode={editMode}
              inputMode={"text"}
              setParentValue={setParentValue}
            />
            <EditableInputDisplay
              id={"city"}
              label={"Città:"}
              initialValue={doctor.city}
              setEditMode={editMode}
              inputMode={"text"}
              setParentValue={setParentValue}
            />
            <EditableInputDisplay
              id={"province"}
              label={"Provincia:"}
              initialValue={doctor.province}
              setEditMode={editMode}
              inputMode={"text"}
              setParentValue={setParentValue}
            />
            <EditableInputDisplay
              id={"cap"}
              label={"CAP:"}
              initialValue={doctor.cap}
              setEditMode={editMode}
              inputMode={"text"}
              setParentValue={setParentValue}
            />
          </Box>
          <Box sx={{ margin: "10px" }}>
            <Typography fontWeight={"bold"} fontStyle={"italic"}>
              Indirizzo secondario
            </Typography>
            {doctor.address_secondary || editMode ? (
              <>
                <EditableInputDisplay
                  id={"address_secondary"}
                  label={"Indirizzo:"}
                  initialValue={doctor.address_secondary}
                  setEditMode={editMode}
                  inputMode={"text"}
                  setParentValue={setParentValue}
                />
                <EditableInputDisplay
                  id={"city_secondary"}
                  label={"Città:"}
                  initialValue={doctor.city_secondary}
                  setEditMode={editMode}
                  inputMode={"text"}
                  setParentValue={setParentValue}
                />
                <EditableInputDisplay
                  id={"province_secondary"}
                  label={"Provincia:"}
                  initialValue={doctor.province_secondary}
                  setEditMode={editMode}
                  inputMode={"text"}
                  setParentValue={setParentValue}
                />
                <EditableInputDisplay
                  id={"cap_secondary"}
                  label={"CAP:"}
                  initialValue={doctor.cap_secondary}
                  setEditMode={editMode}
                  inputMode={"text"}
                  setParentValue={setParentValue}
                />
              </>
            ) : (
              <Typography>Nessun indirizzo secondario specificato</Typography>
            )}
          </Box>
          <Box sx={{ margin: "10px" }}>
            <Typography fontWeight={"bold"} fontStyle={"italic"}>
              Informazioni aggiuntive e contatti
            </Typography>
            <EditableInputDisplay
              id={"date_of_birth"}
              label={"Data di nascita:"}
              initialValue={doctor.date_of_birth}
              setEditMode={editMode}
              inputMode={"date"}
              setParentValue={setParentValue}
            />
            <EditableInputDisplay
              id={"phone"}
              label={"Telefono:"}
              initialValue={doctor.phone}
              setEditMode={editMode}
              inputMode={"text"}
              setParentValue={setParentValue}
            />
            <EditableInputDisplay
              id={"mobile"}
              label={"Cellulare:"}
              initialValue={doctor.mobile}
              setEditMode={editMode}
              inputMode={"text"}
              setParentValue={setParentValue}
            />
            <EditableInputDisplay
              id={"email"}
              label={"Email:"}
              initialValue={doctor.email}
              setEditMode={editMode}
              inputMode={"text"}
              setParentValue={setParentValue}
            />
            <EditableInputDisplay
              id={"note"}
              label={"Note:"}
              initialValue={doctor.note}
              setEditMode={editMode}
              inputMode={"text"}
              setParentValue={setParentValue}
            />
          </Box>
          <Box sx={{ margin: "10px" }}>
            <Typography fontWeight={"bold"} fontStyle={"italic"}>
              Notifiche
            </Typography>
            <EditableInputDisplay
              id={"mobile_alert"}
              label={"Cellulare (alert):"}
              initialValue={doctor.mobile_alert}
              setEditMode={editMode}
              inputMode={"text"}
              setParentValue={setParentValue}
            />
            <EditableInputDisplay
              id={"email_alert"}
              label={"Email (alert):"}
              initialValue={doctor.email_alert}
              setEditMode={editMode}
              inputMode={"text"}
              setParentValue={setParentValue}
            />
          </Box>
        </>
      ) : (
        <LoadingPaper />
      )}
    </Box>
  );
}
